module.exports = __webpack_public_path__ + "static/media/Snapchat-7849457217890981301.042fa56b.jpg";